import { useLazyQuery } from "@apollo/client";
import {
  GetSqlNumberResult,
  GetSqlNumberVars,
  tableKey,
} from "../queries/types";
import { GetSqlNumber } from "../queries/queries";
import { useContext, useEffect } from "react";

import useUrlParams from "./useUrlParams";
import { AppContext } from "../context/context";
import { EMPTY_STRING } from "../utils/constants";
// Adjust the import path as needed

const useSqlNumber = () => {
  const { customer_id, company_id } = useUrlParams();

  const { state } = useContext(AppContext);

  const [GetNumber, { data }] = useLazyQuery<
    GetSqlNumberResult,
    GetSqlNumberVars
  >(GetSqlNumber);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          customer_id &&
          state.ActiveFinYr &&
          (company_id || state.companyId)
        ) {
          GetNumber({
            variables: {
              customerID: customer_id,
              tableKey: tableKey.TICKET,
              companyID: company_id ? company_id : state.companyId,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, company_id, state.companyId, state.ActiveFinYr, GetNumber]);

  return { no: data ? data.GetSqlNumber.sqlNumber : EMPTY_STRING };
};

export default useSqlNumber;
